export type Options = { expires?: Date | string; path?: string; domain?: string };

export function setCookie(name: string, value: string, options: Options = {}) {
  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  const cookie = [];
  cookie.push(`${name}=${value}`);

  // eslint-disable-next-line guard-for-in
  for (let optionKey in options) {
    let optionValue = options[optionKey as keyof Options];
    if (optionValue) {
      cookie.push(`${optionKey}=${optionValue}`);
    }
  }

  document.cookie = cookie.join(';');
}

export function getCookie(name: string) {
  let matches = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`)
  );
  return matches ? matches[1] : undefined;
}
